/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M17.625 12.017h-3.542a3.326 3.326 0 0 0-3.261 2.745.207.207 0 0 1-.205.171h-.834a.206.206 0 0 0-.157.072l-2.73 3.12a.417.417 0 0 1-.73-.275v-2.917H5.75A3.75 3.75 0 0 1 2 11.183V7.85A3.754 3.754 0 0 1 5.75 4.1h8.333a3.754 3.754 0 0 1 3.75 3.75v3.958a.208.208 0 0 1-.208.209Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.39 13.877c.39.39.61.92.61 1.473v2.5a2.083 2.083 0 0 1-2.084 2.083h-1.25v2.084a.417.417 0 0 1-.711.295l-2.378-2.379h-1.494A2.083 2.083 0 0 1 12 17.85v-2.5c0-1.15.932-2.083 2.083-2.083h5.833c.553 0 1.083.22 1.474.61Z"
})), "0 0 24 24", "Messages");